import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "usingAnApp",
  "usingAWebsite",
  "penAndPaper",
  "spreadsheet",
  "mentalMath",
  "other",
] as const

export default function HowCountedCalories() {
  return (
    <MultiSelectPage translationKey="howCountedCalories" options={OPTIONS} />
  )
}
